function Footer() {
  return (
    <footer className="stylefooter">
        <p>QuizAPP. from TechEdu Learning Center © 2025.</p>
    </footer>
  );
}

export default Footer;
